import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

export function useDuplicateVariableMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      return fetchApi(
        {
          endpoint: `/api/variables/${id}/duplicate`,
          method: 'POST',
        },
        { suppressAlert: true },
      )
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['variables', 'list'] })
      void queryClient.invalidateQueries({ queryKey: ['variables', 'all'] })
    },
  })
}
